import { useDragState } from './DragContext';

interface DropMarkerProps {
  zoneId: string | null;
}

// The line showing where the dragged card will land. Positioned absolutely over the grid rather
// than as a grid item, so it never takes up a cell, pushes a card, or grows the grid.
export const DropMarker = ({ zoneId }: DropMarkerProps) => {
  const dragState = useDragState();
  const target = dragState?.dropTarget;
  if (!target || target.zoneId !== zoneId) return null;

  const { marker } = target;
  return (
    <div
      className='dashboard-drop-marker'
      style={{
        left: marker.left,
        top: marker.top,
        width: marker.right - marker.left,
        height: marker.bottom - marker.top
      }}
    />
  );
};
